import React, { useCallback } from 'react'
import { Icon } from '../../style/styled'
import { StopDetails } from './StopDetails'
import { OriginDetails } from './OriginModal'
import { DestinationDetails } from './DestinationModal'
import { CurrentDetails } from './CurrentDetails'
import MileStoneDetails from './MileStoneDetails'
import { useLocation } from 'react-router-dom';
import { debounce } from 'lodash'

const popoverMaxWidth = 275

function popoverPosition(e: any, popoverType: string) {
  let screensize = [window.innerWidth, window.innerHeight]
  let sideBarWidth =
    (document as any)?.querySelector('[data-testid=app-sidebar]')
      ?.offsetWidth || 50
  let pos = []
  let hor = 'left'
  let ver = 'top'
  let leftOffset = e.clientX - sideBarWidth
  if (screensize[0] - 400 < leftOffset) {
    hor = 'right'
    pos[0] = screensize[0] - e.clientX
  } else {
    pos[0] = leftOffset
  }

  if (screensize[1] / 2 > e.clientY) {
    pos[1] = -100
  } else {
    ver = 'bottom'
    pos[1] = 0
  }
  return {
    [hor]: pos[0],
    [ver]: pos[1], // TODO Remove after it works for a long period of time from May 2021
    display: 'block'
  }
}

type TPopover =
  | 'origin'
  | 'destination'
  | 'stop'
  | 'currentDetails'
  | 'milestoneDetails'
interface IIcon {
  popoverType: TPopover
  originData?: any
  details?: any
  styles?: any
  icon?: any
  hideETA?: boolean
  currentDetails?: any
  transportMode?: string
  destinationDetails?: any
  isActiveNode?: boolean
}

export function IconWithPopover({
  icon,
  styles,
  details,
  originData,
  popoverType,
  transportMode,
  currentDetails,
  hideETA,
  destinationDetails,
  isActiveNode
}: IIcon) {
  const [position, setPosition] = React.useState<any>(null)
  const showCurrentDetails = position && popoverType === 'currentDetails'
  const showDestination = position && popoverType === 'destination'
  const showOrigin = position && popoverType === 'origin'
  const showStops = icon && position && popoverType === 'stop'
 
  const location = useLocation();
  const currentURL = location.pathname
  const isShipmentPresent = currentURL.includes('shipment');

  const hidePopover = useCallback(debounce(() => setPosition(null), 
  2000), [])

  return (
    <>
      <Icon
        onMouseOver={(e: any) => {
          setPosition(popoverPosition(e, popoverType))
        }}
        onMouseLeave={() => {
          if (isShipmentPresent) {
            hidePopover();
          } else {
            position && setPosition(null);
          }
        }}
        className="popover-icon"
        style={styles && styles.iconWrapper}
      >
        {icon}
      </Icon>
      {showCurrentDetails ? (
        <CurrentDetails
          positionStyle={{ ...position, maxWidth: popoverMaxWidth }}
          rowData={currentDetails}
        />
      ) : null}
      {showDestination ? (
        <DestinationDetails
          positionStyle={{ ...position, maxWidth: popoverMaxWidth }}
          rowData={destinationDetails}
          transportMode={transportMode}
        />
      ) : null}
      {showOrigin ? (
        <OriginDetails
          positionStyle={{ ...position, maxWidth: popoverMaxWidth }}
          rowData={originData}
          transportMode={transportMode}
        />
      ) : null}

      {isActiveNode && popoverType === 'milestoneDetails' && (
        <MileStoneDetails
          positionStyle={position}
          stopData={details}
          currentData={currentDetails}
        />
      )}
      {showStops && icon && popoverType === 'stop' && (
        <StopDetails
          positionStyle={{ ...position, maxWidth: popoverMaxWidth }}
          details={details}
          hideETA={hideETA}
        />
      )}
    </>
  )
}
